module.exports = __webpack_public_path__ + "media/images/category/dummy/outer01-5d04e1988075c8ff2dd241799404f1a5.jpg";